import { Select, Typography, Option } from '@material-tailwind/react';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import MsgInputError from '../MsgInputError';

const SelectOption = ({ categoriasCompra, field }) => {
  // Memoriza a listaOrganizada para evitar recomputação desnecessária
  const listaOrganizada = useMemo(() => {
    return categoriasCompra.flatMap((item) => [
      { nome: item.nome }, // Adiciona o título
      ...item.categorias.map((categoria) => ({ nome: categoria.nome, id: categoria.id })), // Depois adiciona as categorias
    ]);
  }, [categoriasCompra]);

  return (
    <Select
      labelProps={{ className: `${focus && 'hidden'}` }}
      className="placeholder:text-gray-500 text-gray-900 !border !border-gray-300 placeholder:opacity-100 focus:!border-blue-900 focus:!border-t-blue-900 focus:ring-gray-900/10 bg-white  dark:bg-!darkBgInput"
      size="lg"
      {...field}
    >
      {listaOrganizada.map((item, index) => (
        <Option
          id={`item?.id`}
          value={`${item?.id || ''}`} // Se não houver ID, passa string vazia
          disabled={!item?.id} // Desativa se não tiver ID
          key={index}
          className={`uppercase text-black opacity-100 ${
            item?.id ? '' : 'bg-blue-100 text-center m-1'
          } `}
        >
          <Typography className={`uppercase ${item?.id ? 'font-normal ml-2 ' : 'font-bold'} `}>
            {item.nome}
          </Typography>
        </Option>
      ))}
    </Select>
  );
};
export default function CategoriaSelect({ categoriasCompra, control, errors }) {
  return (
    <div className="w-full flex-1">
      <Typography
        variant="h6"
        color="black"
        className="mb-1 text-left font-medium dark:!text-darkText "
      >
        Categoria Compra *
      </Typography>
      <Controller
        name="categoria"
        control={control}
        defaultValue=""
        rules={{ required: true }}
        render={({ field }) =>
          categoriasCompra.length > 0 && (
            <SelectOption categoriasCompra={categoriasCompra} field={field} />
          )
        }
      />
      {errors && <MsgInputError text={'Este campo é obrigatório'} />}
    </div>
  );
}
